'use client';

import {createContext, useContext} from 'react';

export type Lang = 'id' | 'en'; // keep in sync with your locales

const LocaleCtx = createContext<Lang | null>(null);

export function LocaleProvider({ lang, children }: { lang: Lang; children: React.ReactNode }) {
  return <LocaleCtx.Provider value={lang}>{children}</LocaleCtx.Provider>;
}

export function useLocale() {
  const v = useContext(LocaleCtx);
  if (!v) throw new Error('useLocale must be used inside LocaleProvider');
  return v;
}